import { MarketInfo } from '../types/shopify';

declare global {
  interface Window {
    wakoMarketInfo?: MarketInfo;
  }
}

/**
 * 現在のマーケット情報を取得するフック
 * Shopifyのマーケット機能と連携して、適切な通貨情報を提供する
 */
export const useMarketInfo = (): MarketInfo => {
  // window.wakoMarketInfoから情報を取得（Liquidから注入）
  const marketInfo = window.wakoMarketInfo;
  
  // フォールバック用のデフォルト設定（日本）
  const defaultMarketInfo: MarketInfo = {
    currency: 'JPY',
    currencySymbol: '¥',
    market: 'japan',
    countryCode: 'JP'
  };
  
  // マーケット情報が設定されている場合はそれを使用、なければデフォルト
  return marketInfo || defaultMarketInfo;
};

/**
 * 価格を現在のマーケットに応じてフォーマットする関数
 * @param amount 金額（数値）
 * @param options フォーマットオプション
 * @returns フォーマットされた価格文字列
 */
export const formatPrice = (
  amount: number, 
  options: { 
    showSymbol?: boolean;
    showCurrency?: boolean;
    compact?: boolean;
  } = {}
): string => {
  const { currency, currencySymbol } = useMarketInfo();
  const { showSymbol = true, showCurrency = true, compact = false } = options;
  
  // 通貨別のフォーマット設定
  const formatOptions: Intl.NumberFormatOptions = {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  };
  
  // ロケール設定（日本以外は英語圏ロケールを使用）
  const locale = currency === 'JPY' ? 'ja-JP' : 'en-US';
  
  const formattedAmount = amount.toLocaleString(locale, formatOptions);
  
  if (compact) {
    // コンパクト表示（記号のみ）
    return showSymbol ? `${currencySymbol}${formattedAmount}` : formattedAmount;
  }
  
  // 標準表示
  let result = formattedAmount;
  
  if (showSymbol) {
    result = `${currencySymbol}${result}`;
  }
  
  if (showCurrency) {
    result = `${result} ${currency}`;
  }
  
  return result;
}; 